// extracted by mini-css-extract-plugin
module.exports = {"tail":"StepTail_tail__NaaVp","active":"StepTail_active__bFSrx","number":"StepTail_number__gmLq8","dot":"StepTail_dot__3Kt6_","line":"StepTail_line__CRDrX"};